var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { Order } from '../../../model/order';
import { ModalConfig } from '../../../model/modal-config';
import { EmitterConstants } from '../../../shared/emitter-constants';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { BaseActions } from '../../../shared/base-actions';
import { takeUntil } from 'rxjs/operators';
import { OcapiService } from '../../../services/ocapi/ocapi.service';
import { TrialSalesOffersMapper } from '../../../shared/mappers/trial/trial-sales-offers-mapper';
import { ErrorMessageConstants } from '../../../shared/error-message-constants';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { KeyDirections } from '../../../shared/key-directions.enum';
import { TvshopConstants } from '../../../shared/tvshop-constants';
import { Error } from '../../../model/error';
import { LanguageService } from '../../../services/language/language.service';
import { TrialUtils } from '../../../shared/utils/trial/trial-utils';
import { DtvCatalogUtils } from '../../../utils/dtv-catalog/dtv-catalog.utils';
import { OmapiIdsUtils } from '../../../shared/utils/omapi-ids/omapi-ids-utils';
import { UserTypeConstants } from '../../../shared/user-type-constants';
import { OcapiSynchronousService } from '../../../services/ocapi/ocapi.synchronous.service';
import { OcapiAsynchronousService } from '../../../services/ocapi/ocapi.asynchronous.service';
import { TvShopStateService } from '../../../services/state/tv-shop-state.service';
var TrialCodeModalComponent = /** @class */ (function (_super) {
    __extends(TrialCodeModalComponent, _super);
    function TrialCodeModalComponent(navigationService, ocapiService, ocapiSynchronousService, ocapiAsynchronousService, languageService, stateService, analyticsService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.ocapiService = ocapiService;
        _this.ocapiSynchronousService = ocapiSynchronousService;
        _this.ocapiAsynchronousService = ocapiAsynchronousService;
        _this.languageService = languageService;
        _this.stateService = stateService;
        _this.analyticsService = analyticsService;
        _this.runningTrials = [];
        _this.isCodeValid = true;
        _this.ownerComponent = PageNames.TRIAL_CODE_MODAL;
        _this.voucherErrorCode = ErrorMessageConstants.VOUCHER_NOT_VALID;
        _this.elementArray = [];
        _this.focussedElementIndex = 1;
        _this.unavailableReasons = new Set();
        _this.trialAlreadyExists = false;
        _this.availableSalesOffers = [];
        _this.chosenTrial = undefined;
        return _this;
    }
    TrialCodeModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.doneLoading = true;
        Emitter.of(EmitterConstants.INPUT_TRIAL_CODE).pipe(takeUntil(this.stopSubscription)).subscribe(function (value) {
            _this.code = value.code;
            _this.isCodeValid = true;
        });
        this.elementArray.push(this.modalHeader);
        this.elementArray.push(this.confirm);
        this.elementArray.push(this.conditions);
    };
    TrialCodeModalComponent.prototype.retrieveTrialSalesOffers = function () {
        var _this = this;
        this.unavailableReasons = new Set();
        this.isCodeValid = !!this.code;
        this.doneLoading = false;
        if (this.code) {
            this.ocapiService.retrieveTrialOffers(this.code).pipe(takeUntil(this.stopSubscription)).subscribe(function (trialSalesOffers) {
                _this.handleTrialSalesOffer(trialSalesOffers);
            }, function (error) {
                _this.handleTrialErrorResponse(error);
            });
        }
        else {
            this.doneLoading = true;
            this.voucherErrorCode = ErrorMessageConstants.VOUCHER_NOT_VALID;
            this.attemptsRemaining = undefined;
        }
        this.activateTimeout();
    };
    TrialCodeModalComponent.prototype.handleTrialSalesOffer = function (trialSalesOffers) {
        var _this = this;
        var thereAreValidTrials = this.validateTrialSalesOffers(trialSalesOffers);
        if (thereAreValidTrials) {
            if (trialSalesOffers && trialSalesOffers.length === 1) {
                var trial = TrialSalesOffersMapper.mapToTrial(trialSalesOffers[0], this.code);
                this.analyticsService.onVoucherCodeResolved([trial.omapiId]);
                this.activateTrial(trialSalesOffers);
            }
            else if (trialSalesOffers && trialSalesOffers.length > 1) {
                this.analyticsService.onVoucherCodeResolved(trialSalesOffers.map(function (value) { return TrialSalesOffersMapper.mapToTrial(value, _this.code).omapiId; }));
                this.openComparisonModal(trialSalesOffers);
            }
        }
        else {
            this.voucherErrorCode = this.trialAlreadyExists ? this.voucherErrorCode : ErrorMessageConstants.VOUCHER_NOT_VALID;
            this.analyticsService.onVoucherCodeFailed();
            this.logInvalidTrialSalesOffers();
        }
    };
    TrialCodeModalComponent.prototype.handleTrialErrorResponse = function (error) {
        this.containsErrors('An error has been encountered while retrieving the TrialsSalesOffers', error);
        this.attemptsRemaining = undefined;
        this.analyticsService.onVoucherCodeFailed();
        this.isCodeValid = false;
        this.mapVoucherErrorCodes(error.error ? error.error.code : ErrorMessageConstants.VOUCHER_NOT_VALID);
        if (this.voucherErrorCode === ErrorMessageConstants.MAX_ATTEMPTS_REACHED) {
            this.doneLoading = true;
            Emitter.of(EmitterConstants.OPEN_TRIAL_MAX_ATTEMPTS_REACHED_MODAL).emit();
        }
        else {
            this.logInvalidTrialSalesOffers();
        }
    };
    TrialCodeModalComponent.prototype.logErrorNoTrialSalesOfferFound = function () {
        this.isCodeValid = false;
        this.containsErrors('No TrialSalesOffer has been found for this trial', undefined);
    };
    TrialCodeModalComponent.prototype.logInvalidTrialSalesOffers = function () {
        this.isCodeValid = false;
        this.doneLoading = true;
        this.containsErrors('TrialSalesOffers are not valid', undefined);
    };
    TrialCodeModalComponent.prototype.activateTrial = function (trialSalesOffers) {
        var _this = this;
        this.doneLoading = false;
        this.chosenTrial = TrialSalesOffersMapper.mapToTrial(trialSalesOffers[0], this.code);
        this.analyticsService.onVoucherCodeEntered();
        var activateTrialObservable;
        if (OmapiIdsUtils.currentUserType === UserTypeConstants.LEGACY_USER) {
            activateTrialObservable = this.ocapiAsynchronousService.activateTrial(this.chosenTrial);
        }
        else if (OmapiIdsUtils.currentUserType === UserTypeConstants.DWN_USER) {
            activateTrialObservable = this.ocapiSynchronousService.activateTrial(this.chosenTrial);
        }
        activateTrialObservable.pipe(takeUntil(this.stopSubscription))
            .subscribe(function (response) {
            Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL).emit(_this.chosenTrial);
            _this.doneLoading = true;
            var packs = _this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
            DtvCatalogUtils.onTrialActivated(packs, _this.chosenTrial);
            _this.stateService.setTvShopEntertainmentPacks(packs);
        }, function (error1) { return _this.containsErrors('Trial could not be activated', error1); });
    };
    TrialCodeModalComponent.prototype.openComparisonModal = function (trialSalesOffers) {
        this.doneLoading = true;
        Emitter.of(EmitterConstants.OPEN_TRIAL_COMPARISON_MODAL).emit(TrialSalesOffersMapper.mapToTrials(trialSalesOffers, this.code));
    };
    TrialCodeModalComponent.prototype.onBack = function () {
        document.activeElement.blur();
        this.doneLoading = true;
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.ownerComponent);
    };
    TrialCodeModalComponent.prototype.openConditional = function () {
        this.doneLoading = true;
        Emitter.of(EmitterConstants.OPEN_CONDITIONAL_MODAL).emit(this.ownerComponent);
    };
    TrialCodeModalComponent.prototype.openTrialActivationTimeout = function () {
        var pendingError = new Error('timeout', 'Your order is pending but there is currently no response.');
        Emitter.of(EmitterConstants.OPEN_TRIAL_ACTIVATION_TIMEOUT).emit({
            trial: this.chosenTrial,
            component: this.ownerComponent,
            error: pendingError
        });
    };
    TrialCodeModalComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
    };
    TrialCodeModalComponent.prototype.validateTrialSalesOffers = function (trialSalesOffers) {
        var thereAreValidTrials = false;
        this.availableSalesOffers = [];
        if (trialSalesOffers && trialSalesOffers.length > 0) {
            this.enrichAvailableSalesOffersAndUnavailableReasons(trialSalesOffers);
            var isSalesOffer1Valid = trialSalesOffers[0].voucherisvalid && this.availableSalesOffers[0];
            var isSalesOffer1And2Valid = isSalesOffer1Valid && (trialSalesOffers.length > 1 ? trialSalesOffers[1].voucherisvalid && this.availableSalesOffers[1] : true);
            this.attemptsRemaining = '' + trialSalesOffers[0].attemptsremaining;
            thereAreValidTrials = this.isCodeValid = trialSalesOffers.length === 1 ? isSalesOffer1Valid : isSalesOffer1And2Valid;
            if (isSalesOffer1And2Valid && this.trialSalesOfferAlreadyExists(trialSalesOffers)) {
                this.voucherErrorCode = ErrorMessageConstants.TRIAL_ALREADY_RUNNING;
                this.trialAlreadyExists = true;
                this.containsErrors('You already have this trial', 'Already Subscribed!');
                return this.isCodeValid = false;
            }
            this.voucherErrorCode = trialSalesOffers[0].voucherisvalid ? this.voucherErrorCode : ErrorMessageConstants.VOUCHER_NOT_VALID;
        }
        else {
            this.analyticsService.onVoucherCodeFailed();
            this.logErrorNoTrialSalesOfferFound();
            thereAreValidTrials = false;
        }
        return thereAreValidTrials;
    };
    TrialCodeModalComponent.prototype.enrichAvailableSalesOffersAndUnavailableReasons = function (trialSalesOffers) {
        this.enrichtAvailableSalesOffers(trialSalesOffers);
        this.enrichUnavailableReasons(trialSalesOffers);
    };
    TrialCodeModalComponent.prototype.enrichUnavailableReasons = function (trialSalesOffers) {
        var _this = this;
        trialSalesOffers.filter(function (trialSalesOffer) { return !trialSalesOffer.salesofferisavailable
            && trialSalesOffer.unavailablereasons
            && Object.entries(trialSalesOffer.unavailablereasons).length > 0; }).forEach(function (trialSalesOffer) {
            var currentLanguage = (_this.languageService.getCurrentLanguage() + '').toUpperCase();
            var unavailableReason = trialSalesOffer.unavailablereasons[currentLanguage] + ''.trim();
            unavailableReason = unavailableReason.endsWith('.') ? unavailableReason :
                unavailableReason.endsWith('!') ? unavailableReason : unavailableReason.concat('.');
            _this.unavailableReasons.add(unavailableReason);
        });
    };
    TrialCodeModalComponent.prototype.enrichtAvailableSalesOffers = function (trialSalesOffers) {
        var _this = this;
        trialSalesOffers.forEach(function (trialSalesOffer) { return _this.availableSalesOffers.push(trialSalesOffer.salesofferisavailable); });
    };
    TrialCodeModalComponent.prototype.mapVoucherErrorCodes = function (errorCode) {
        this.voucherErrorCode = ErrorMessageConstants.OCAPI_ERROR_MAP.get(errorCode) || ErrorMessageConstants.VOUCHER_GENERIC_ERROR;
    };
    TrialCodeModalComponent.prototype.onKeyDown = function (event) {
        if (event.keyCode === KeyDirections.ARROW_DOWN && this.focussedElementIndex < this.elementArray.length - 1) {
            this.focussedElementIndex++;
            this.elementArray[this.focussedElementIndex].nativeElement.scrollIntoViewIfNeeded();
        }
        if (event.keyCode === KeyDirections.ARROW_UP && this.focussedElementIndex > 0) {
            this.focussedElementIndex--;
            this.elementArray[this.focussedElementIndex].nativeElement.scrollIntoViewIfNeeded();
        }
    };
    TrialCodeModalComponent.prototype.activateTimeout = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.doneLoading) {
                _this.doneLoading = true;
                _this.openTrialActivationTimeout();
                _this.containsErrors('The order is pending.');
            }
        }, TvshopConstants.MAXIMUM_ORDERING_COOL_DOWN_IN_MS);
    };
    TrialCodeModalComponent.prototype.trialSalesOfferAlreadyExists = function (trialSalesOffers) {
        if (this.runningTrials.length > 0) {
            for (var _i = 0, trialSalesOffers_1 = trialSalesOffers; _i < trialSalesOffers_1.length; _i++) {
                var trialSalesOffer = trialSalesOffers_1[_i];
                if (this.trialWithOmapiIdAlreadyExists(trialSalesOffer)) {
                    this.attemptsRemaining = undefined;
                    return true;
                }
            }
        }
        return false;
    };
    TrialCodeModalComponent.prototype.trialWithOmapiIdAlreadyExists = function (trialSalesOffer) {
        var omapiId = TrialUtils.getTrialOmapiIdForTrialLabel(trialSalesOffer.labelkey);
        return !!this.runningTrials.find(function (runningTrial) { return runningTrial.omapiId === omapiId; });
    };
    return TrialCodeModalComponent;
}(BaseActions));
export { TrialCodeModalComponent };
